export type OpenPopUpTabArgs = {
  url: string;
  onClose?: () => void;
};

export const openPopUpTab = ({ url, onClose }: OpenPopUpTabArgs) => {
  const popUp = window.open(url, '_blank');

  if (popUp && onClose) {
    const interval = setInterval(() => {
      if (popUp.closed) {
        onClose();
        clearInterval(interval);
      }
    }, 1000);
  }

  return popUp;
};
